import { inject } from '@angular/core';
import { CanActivateFn, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from './auth.service';
import { KeycloakService } from './keycloak.service';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { StorageService } from './storage.service';

export const authGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): Observable<boolean> => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const storageService = inject(StorageService);
  const keycloakService = inject(KeycloakService);

  // Use validateSession which handles token expiration check and refresh
  return authService.validateSession().pipe(
    map((isValid) => {
      if (isValid) {
        return true;
      }

      // Session invalid.
      // Authorization Code + PKCE mode: redirect to the Keycloak-hosted (branded) login.
      if (keycloakService.enabled) {
        console.log('Session invalid, redirecting to Keycloak login');
        keycloakService.login(state.url);
        return false;
      }

      // Password mode: redirect to the in-app login page.
      console.log('Session invalid, redirecting to login');
      storageService.saveRedirectUrl(state.url);
      redirectToLogin(router, storageService);
      return false;
    }),
    catchError((err) => {
      console.error('Auth guard error:', err);
      if (keycloakService.enabled) {
        keycloakService.login(state.url);
        return of(false);
      }
      storageService.saveRedirectUrl(state.url);
      redirectToLogin(router, storageService);
      return of(false);
    })
  );
};

function redirectToLogin(router: Router, storageService: StorageService): void {
  setTimeout(() => {
    router.navigateByUrl('/account/login').catch(err => {
      console.error('Navigation to login failed:', err);
      storageService.forceRedirectToLogin();
    });
  }, 0);
}
